import React from "react";
import bg from "../../assets/skills.jpg";
const CartItems = ({
  cartData,
  handleAddToCart,
  handleRemoveToCart,
  handleChange,
}) => {
  return (
    <>
      <div className="all_select_btn">
        <div className="radio_btn">
          {/* <input type="checkbox" name="product" id="product" />
              All */}
        </div>
        {cartData.map((item, idx) => {
          const { price, name, total, _id, points, thumbnail, piecesLeft } =
            item;
          const eachProductTotalPrice = price * (total ? total : 1);

          return (
            <div
              className={
                piecesLeft <= 0
                  ? "product_cart_details cart_out_of_stock"
                  : "product_cart_details"
              }
              key={_id}
            >
              <div className="product">
                <input
                  disabled={piecesLeft <= 0}
                  type="checkbox"
                  value={_id}
                  name="product"
                  id="product"
                  onChange={(e) => handleChange(e, item)}
                />
                <div className="cart_thumbnail">
                  <img
                    src={
                      thumbnail
                        ? `https://drive.google.com/thumbnail?id=${thumbnail}`
                        : bg
                    }
                    alt=""
                  />
                </div>
                <div className="product_details">
                  <div>
                    <div className="row align">
                      <strong>{name}</strong>
                      {piecesLeft > 0 && (
                        <p className="pieces_left">{piecesLeft} pcs left</p>
                      )}
                    </div>

                    <div className="variations"></div>
                    {piecesLeft <= 0 ? (
                      <button
                        className="remove_btn"
                        onClick={() => handleRemoveToCart(idx, _id, 0)}
                      >
                        Remove
                      </button>
                    ) : (
                      <div className="quantity_btn">
                        <button
                          disabled={piecesLeft <= 0}
                          onClick={() => {
                            handleRemoveToCart(idx, _id, total);
                          }}
                        >
                          -
                        </button>
                        <p>{total > piecesLeft ? piecesLeft : total}</p>
                        <button
                          disabled={piecesLeft <= 0 || total >= piecesLeft}
                          onClick={() => {
                            handleAddToCart(_id, idx);
                          }}
                        >
                          +
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              {piecesLeft <= 0 && (
                <p className="out_of_stock_text">Out of stock</p>
              )}
              <div className="quantity">
                <h3>₱{eachProductTotalPrice.toFixed(2)}</h3>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default CartItems;
